export const REPORT_TEMPLATE_SCHEMA_VERSION = '0.2.0';

export const REPORT_TEMPLATE_DATA_SOURCES = {
  fascicolo: { id: 'fascicolo', labelKey: 'reports.review.template.dataSources.fascicolo' },
  stationInventory: { id: 'stationInventory', labelKey: 'reports.review.template.dataSources.stationInventory' },
  sensorData: { id: 'sensorData', labelKey: 'reports.review.template.dataSources.sensorData' },
  productionBenchmark: { id: 'productionBenchmark', labelKey: 'reports.review.template.dataSources.productionBenchmark' },
  maps: { id: 'maps', labelKey: 'reports.review.template.dataSources.maps' },
  userInput: { id: 'userInput', labelKey: 'reports.review.template.dataSources.userInput' },
};

export const REPORT_TEMPLATE_MODULE_SOURCES = {
  m0: ['fascicolo', 'stationInventory', 'userInput'],
  m1: {
    relazione_agronomica_primo_anno: ['stationInventory', 'maps', 'userInput'],
    relazione_agronomica_annuale: ['productionBenchmark', 'userInput'],
  },
  m2: ['sensorData', 'stationInventory', 'userInput'],
  m3: ['sensorData', 'stationInventory', 'userInput'],
  m4: ['sensorData', 'stationInventory', 'userInput'],
};

export const REPORT_TEMPLATE_SCHEMA = {
  relazione_agronomica_primo_anno: {
    id: 'relazione_agronomica_primo_anno',
    titleKey: 'reports.review.template.reportTypes.firstYear',
    sections: [
      { id: 'cover', type: 'cover', order: 0, includeInToc: false },
      { id: 'toc', type: 'toc', order: 1, includeInToc: false },
      {
        id: 'premessa',
        type: 'outline',
        order: 2,
        titleKey: 'reports.review.template.sections.premessa',
      },
      {
        id: 'objectives',
        type: 'outline',
        order: 3,
        titleKey: 'reports.review.template.sections.objectives',
      },
      {
        id: 'environmental-analysis',
        type: 'outline',
        order: 4,
        titleKey: 'reports.review.template.sections.environmentalAnalysis',
      },
      {
        id: 'piano-colturale',
        type: 'outline',
        order: 5,
        titleKey: 'reports.review.template.sections.plan',
      },
      {
        id: 'mechanization',
        type: 'outline',
        order: 6,
        titleKey: 'reports.review.template.sections.mechanization',
      },
      {
        id: 'crop-succession',
        type: 'outline',
        order: 7,
        titleKey: 'reports.review.template.sections.cropSuccession',
      },
      {
        id: 'implementation-analysis',
        type: 'outline',
        order: 8,
        titleKey: 'reports.review.template.sections.implementationAnalysis',
      },
      {
        id: 'construction-compatibility',
        type: 'outline',
        order: 9,
        titleKey: 'reports.review.template.sections.constructionCompatibility',
      },
      {
        id: 'integrated-project',
        type: 'outline',
        order: 10,
        titleKey: 'reports.review.template.sections.integratedProject',
      },
      {
        id: 'costs-plv',
        type: 'outline',
        order: 11,
        titleKey: 'reports.review.template.sections.costsPlv',
      },
      {
        id: 'guidelines-compliance',
        type: 'outline',
        order: 12,
        titleKey: 'reports.review.template.sections.guidelinesCompliance',
      },
      {
        id: 'conclusions',
        type: 'conclusions',
        order: 13,
        titleKey: 'reports.review.template.sections.conclusions',
      },
      { id: 'gaps', type: 'gapReport', order: 98, includeInToc: false },
      {
        id: 'metadata',
        type: 'metadata',
        order: 99,
        titleKey: 'reports.review.template.sections.metadata',
        includeInToc: false,
      },
    ],
  },
  relazione_agronomica_annuale: {
    id: 'relazione_agronomica_annuale',
    titleKey: 'reports.review.template.reportTypes.annual',
    sections: [
      { id: 'cover', type: 'cover', order: 0, includeInToc: false },
      { id: 'toc', type: 'toc', order: 1, includeInToc: false },
      {
        id: 'premessa',
        type: 'outline',
        order: 2,
        titleKey: 'reports.review.template.sections.premessa',
      },
      {
        id: 'objectives',
        type: 'outline',
        order: 3,
        titleKey: 'reports.review.template.sections.objectives',
      },
      {
        id: 'environmental-analysis',
        type: 'outline',
        order: 4,
        titleKey: 'reports.review.template.sections.environmentalAnalysis',
      },
      {
        id: 'piano-colturale',
        type: 'outline',
        order: 5,
        titleKey: 'reports.review.template.sections.plan',
      },
      {
        id: 'mechanization',
        type: 'outline',
        order: 6,
        titleKey: 'reports.review.template.sections.mechanization',
      },
      {
        id: 'crop-succession',
        type: 'outline',
        order: 7,
        titleKey: 'reports.review.template.sections.cropSuccession',
      },
      {
        id: 'implementation-analysis',
        type: 'outline',
        order: 8,
        titleKey: 'reports.review.template.sections.implementationAnalysis',
      },
      {
        id: 'construction-compatibility',
        type: 'outline',
        order: 9,
        titleKey: 'reports.review.template.sections.constructionCompatibility',
      },
      {
        id: 'integrated-project',
        type: 'outline',
        order: 10,
        titleKey: 'reports.review.template.sections.integratedProject',
      },
      {
        id: 'costs-plv',
        type: 'outline',
        order: 11,
        titleKey: 'reports.review.template.sections.costsPlv',
      },
      {
        id: 'guidelines-compliance',
        type: 'outline',
        order: 12,
        titleKey: 'reports.review.template.sections.guidelinesCompliance',
      },
      {
        id: 'conclusions',
        type: 'conclusions',
        order: 13,
        titleKey: 'reports.review.template.sections.conclusions',
      },
      { id: 'gaps', type: 'gapReport', order: 98, includeInToc: false },
      {
        id: 'metadata',
        type: 'metadata',
        order: 99,
        titleKey: 'reports.review.template.sections.metadata',
        includeInToc: false,
      },
    ],
  },
};
